angular.module("ainapp")
    .controller("CostCenterTreeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Cost Center";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Profile = {};
            MainService.GetCompanyProfile().then(function (response) {
                $scope.Profile = response.data;
            })



            $scope.Init = function () {

                $scope.load = true;
                $scope.CostDesign = {};


                $scope.CurrentCostCenter = {
                    Name: "",
                    Level: 1,
                    Description: "",
                    Code: "",
                    ParentId: "",
                    IsActive: true,
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    Field11: "",
                    Field12: "",
                    Field13: "",
                    Field14: "",
                    Field15: "",
                    Field16: null,
                    Field17: null,
                    Field18: null,
                    Field19: null,
                    Field20: null,
                }

                $scope.ShowAddFix = false;
                $scope.ShowEditFix = false;
                $scope.SelectedGroup = {};

            }
            $scope.Init();


            $scope.treelistOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            MainService.CostCentersInKendoTree().then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success([]);
                                toastr.error("NetworkError");
                            })
                        },
                    },
                    schema: {
                        model: {
                            id: "Id",
                            parentId: "ParentId",
                            fields: {
                                ParentId: {
                                    field: "ParentId",
                                    nullable: true
                                },
                                Name: {
                                    field: "Name",
                                    type: "string"
                                },
                                Code: {
                                    field: "Code",
                                    type: "string"
                                },
                                Address: {
                                    field: "Address",
                                    type: "string"
                                },
                                IsHide: {
                                    field: "IsHide",
                                    type: "boolean"
                                },
                            },
                            expanded: false
                        }
                    }
                },

                editable: false,
                toolbar: ["excel"],
                height: 600,
                //resizable: true,
                sortable: true,
                //scrollable: true,
                filterable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Code",
                        title: "Code",
                                        },
                    {
                        field: "Name",
                        title: "Name",
                                        }, {
                        field: "Address",
                        title: "Address",
                                        },
                    {
                        field: "IsHide",
                        title: "Active Status",
                        width: "100px",
                        template: "<p ng-if='dataItem.IsHide'> In-Active </p> <p ng-if='!dataItem.IsHide'> Active </p>"
                        },
                    {
                        title: "Options",
                        template: "<button ng-if='!dataItem.ParentId > 0' class=' btn-default btn-sm fa fa-plus' ng-click='ShowAddModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-pencil' ng-click='ShowEditModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccount(dataItem)'></button>  ",
                        width: '100px'
                        },

                                    ],
            };




            $scope.GetSub = function (data) {
                MainService.CostCenterSubList(data.Id).then(function (response) {
                    data.Children = response.data;
                    data.IsOpen = true;
                }, function (err) {
                    $scope.load = false;
                });
            }

            $scope.CloseSub = function (data) {
                data.IsOpen = false;
            }

            $scope.refreshForm = function () {

                $scope.CurrentCostCenter = {
                    Name: "",
                    Level: "",
                    Description: "",
                    ParentId: "",
                    Code: "",
                    IsActive: true,

                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    Field11: "",
                    Field12: "",
                    Field13: "",
                    Field14: "",
                    Field15: "",
                    Field16: null,
                    Field17: null,
                    Field18: null,
                    Field19: null,
                    Field20: null,
                }
                $("#addCostModal").modal("hide");

            }

            $scope.ShowAddModel = function (data) {

                $scope.CostDesign = {};
                MainService.GetCostCenterDesign(data.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.CostDesign = response.data;
                    } else {
                        $scope.CostDesign = {};
                    }

                    $scope.CurrentCostCenter = {
                        Name: "",
                        Level: 2,
                        Description: "",
                        Address: "",
                        ParentId: data.Id,
                        Code: "",
                        IsActive: true,
                        Field1: "",
                        Field2: "",
                        Field3: "",
                        Field4: "",
                        Field5: "",
                        Field6: "",
                        Field7: "",
                        Field8: "",
                        Field9: "",
                        Field10: "",
                        Field11: "",
                        Field12: "",
                        Field13: "",
                        Field14: "",
                        Field15: "",
                        Field16: null,
                        Field17: null,
                        Field18: null,
                        Field19: null,
                        Field20: null,
                    }

                    if ($scope.CostDesign.IsAutoCode) {

                        MainService.GetNextCoseCenterNo(data.Name).then(function (response) {
                            $scope.CurrentCostCenter.Code = response.data;
                        })

                    }

                    $scope.load = false;
                }, function (err) {
                    $scope.load = false;
                });



                $scope.SelectedGroup = data;
                $("#addCostModal").modal("show");

            }

            $scope.ShowAddMainModel = function () {

                $scope.CurrentCostCenter = {
                    Name: "",
                    Level: 1,
                    Description: "",
                    Address: "",
                    ParentId: "",
                    Code: "",
                    IsActive: true,
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    Field11: "",
                    Field12: "",
                    Field13: "",
                    Field14: "",
                    Field15: "",
                    Field16: null,
                    Field17: null,
                    Field18: null,
                    Field19: null,
                    Field20: null,
                }

                if ($scope.Profile.IsAutoCostCenterNo) {

                    MainService.GetNextCostCenterNo().then(function (response) {
                        $scope.CurrentCostCenter.Code = response.data;
                    })

                }

                $("#addCostModal").modal("show");

                $scope.SelectedGroup = {};

            }

            $scope.ShowEditModel = function (data) {
                $scope.CurrentCostCenter = data;
                $("#addCostModal").modal("show");
                if (data.ParentId > 0) {
                    $scope.SelectedGroup = {
                        Id: data.ParentId
                    };

                    $scope.CostDesign = {};
                    MainService.GetCostCenterDesign(data.ParentId).then(function (response) {
                        if (response.data != null) {
                            $scope.CostDesign = response.data;
                        } else {
                            $scope.CostDesign = {};
                        }
                        $scope.load = false;
                    }, function (err) {
                        $scope.load = false;
                    });

                } else {
                    $scope.SelectedGroup = {};
                }
            }


            $scope.saveCostCenter = function () {

                if ($scope.CurrentCostCenter.Name == "") {
                    toastr.warning("Give Cost Center Name");
                } else if ($scope.CurrentCostCenter.Code == "") {
                    toastr.warning("Give Cost Center Code");
                } else if ($scope.CurrentCostCenter.Description == "" && $scope.CostDesign.IsDescriptionMandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter Description");
                } else if ($scope.CurrentCostCenter.Address == "" && $scope.CostDesign.IsAddressMandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter Address");
                } else if ($scope.CurrentCostCenter.Field1 == "" && $scope.CostDesign.IsField1Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field1);
                } else if ($scope.CurrentCostCenter.Field2 == "" && $scope.CostDesign.IsField2Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field2);
                } else if ($scope.CurrentCostCenter.Field3 == "" && $scope.CostDesign.IsField3Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field3);
                } else if ($scope.CurrentCostCenter.Field4 == "" && $scope.CostDesign.IsField4Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field4);
                } else if ($scope.CurrentCostCenter.Field5 == "" && $scope.CostDesign.IsField5Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field5);
                } else if ($scope.CurrentCostCenter.Field6 == "" && $scope.CostDesign.IsField6Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field6);
                } else if ($scope.CurrentCostCenter.Field7 == "" && $scope.CostDesign.IsField7Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field7);
                } else if ($scope.CurrentCostCenter.Field8 == "" && $scope.CostDesign.IsField8Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field8);
                } else if ($scope.CurrentCostCenter.Field9 == "" && $scope.CostDesign.IsField9Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field9);
                } else if ($scope.CurrentCostCenter.Field10 == "" && $scope.CostDesign.IsField10Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field10);
                } else if ($scope.CurrentCostCenter.Field11 == "" && $scope.CostDesign.IsField11Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field11);
                } else if ($scope.CurrentCostCenter.Field12 == "" && $scope.CostDesign.IsField12Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field12);
                } else if ($scope.CurrentCostCenter.Field13 == "" && $scope.CostDesign.IsField13Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field13);
                } else if ($scope.CurrentCostCenter.Field14 == "" && $scope.CostDesign.IsField14Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field14);
                } else if ($scope.CurrentCostCenter.Field15 == "" && $scope.CostDesign.IsField15Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field15);
                } else if ($scope.CurrentCostCenter.Field16 == null && $scope.CostDesign.IsField16Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field16);
                } else if ($scope.CurrentCostCenter.Field17 == null && $scope.CostDesign.IsField17Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field17);
                } else if ($scope.CurrentCostCenter.Field18 == null && $scope.CostDesign.IsField18Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field18);
                } else if ($scope.CurrentCostCenter.Field19 == null && $scope.CostDesign.IsField19Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field19);
                } else if ($scope.CurrentCostCenter.Field20 == null && $scope.CostDesign.IsField20Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field20);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddCostCenter($scope.CurrentCostCenter).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Cost Center Saved");
                            $("#addCostModal").modal("hide");
                            $scope.ktl.dataSource.read();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }

            }

            $scope.SelectedAccForDelete = {};
            $scope.DeleteAccount = function (data) {
                $scope.SelectedAccForDelete = data;
                $("#myModal2").modal("show");
            }

            $scope.deleteWithConfirm = function (temp) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCostCenter($scope.SelectedAccForDelete.Id, temp).then(function (response) {
                    if (response.data == "Success") {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $scope.SelectedAccForDelete = {};
                        $scope.ktl.dataSource.read();

                    } else {
                        toastr.warning(response.data);
                        $scope.SelectedAccForDelete = {};
                        $('#myModal2').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.load = 0;
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            /////////////////// EXTRA AUTO COMPLETE //////////////////

            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.CostcenterFieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

        }])
